module.exports = __webpack_public_path__ + "static/media/top-filter-active-light-icon.5eb4ebc5.svg";